<template>
    <div>
        <div
            v-if="rightSlotName !== '' && showRightSlot"
            class="right-slot"
        >
            <keep-alive>
                <component :is="rightSlotName" />
            </keep-alive>
        </div>
        <guide
            v-show="guideTextNotEmpty"
            :guide-text="guideText"
        />
        <p
            v-if="dataUpdatedDate != null"
            class="dataUpdatedDate"
        >
            <!-- eslint-disable vue/no-v-html -->
            <span v-html="dataUpdatedDate" />
            <!--eslint-enable-->
        </p>
        <div
            v-if="searchAddressSelected !== null && isSearchAddressVisible"
            class="search-address-focus"
        >
            <a
                tabindex="0"
                @click="searchAddressFocus"
                @keydown.enter="searchAddressFocus"
            >
                {{ searchFieldLabel }}
            </a>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-facing-decorator"
    import Guide from "@/components/Guide.vue"
    import SearchResultModel from "@/models/searchresultmodel"
    import useEventsBus from "@/eventBus"
    // TieLiikenne
    import MyonnetytTaksiluvat from "@/views/Liikenne/Tieliikenne/RightSlots/MyonnetytTaksiluvat.vue"
    import LupaJaRekisterointitoimipaikat from "@/views/Liikenne/Tieliikenne/RightSlots/LupaJaRekisterointitoimipaikat.vue"
    import EnsirekisteroidytHenkiloAutot from "@/views/Liikenne/Tieliikenne/RightSlots/EnsirekisteroidytHenkiloAutot.vue"
    import EnsirekisteroidytHenkiloAutotPaastot from "@/views/Liikenne/Tieliikenne/RightSlots/EnsirekisteroidytHenkiloAutotPaastot.vue"
    import LiikennekaytossaHenkiloAutot from "@/views/Liikenne/Tieliikenne/RightSlots/LiikennekaytossaHenkiloAutot.vue"
    import LiikennekaytossaHenkiloAutotKeskiIka from "@/views/Liikenne/Tieliikenne/RightSlots/LiikennekaytossaHenkiloAutotKeskiIka.vue"
    import Liikenneonnettomuudet from "@/views/Liikenne/Tieliikenne/RightSlots/Liikenneonnettomuudet.vue"
    import VoimassaOlevatAjokortit from "@/views/Liikenne/Tieliikenne/RightSlots/VoimassaOlevatAjokortit.vue"
    // TV ja Radio
    import TVPeittoalueet from "@/views/Viestinta/TVJaRadio/RightSlots/TVPeittoalueet.vue"
    import AntenniTVSaatavuus from "@/views/Viestinta/TVJaRadio/RightSlots/AntenniTVSaatavuus.vue"
    import RadioPeittoalueet from "@/views/Viestinta/TVJaRadio/RightSlots/RadioPeittoalueet.vue"
    import RadioasemienKuuluvuus from "@/views/Viestinta/TVJaRadio/RightSlots/RadioasemienKuuluvuus.vue"
    // Viat ja Häiriöt
    import ViatJaHairiotTiedot from "@/views/Viestinta/ViatJaHairiot/RightSlots/ViatJaHairiotTiedot.vue"
    // Laajakaista ja puhelin
    import KiinteanLaajakaistanSaatavuus from "@/views/Viestinta/LaajakaistaJaPuhelin/RightSlots/KiinteanLaajakaistanSaatavuus.vue"
    import MobiiliverkonKattavuus from "@/views/Viestinta/LaajakaistaJaPuhelin/RightSlots/MobiiliverkonKattavuus.vue"
    import Laajakaistahankkeet from "@/views/Viestinta/LaajakaistaJaPuhelin/RightSlots/Laajakaistahankkeet.vue"
    import OikeusPuhelinJaLaajakaistaLiittymaan from "@/views/Viestinta/LaajakaistaJaPuhelin/RightSlots/OikeusPuhelinJaLaajakaistaLiittymaan.vue"
    import KiinteanVerkonSaatavuusRuuduilla from "@/views/Viestinta/LaajakaistaJaPuhelin/RightSlots/KiinteanVerkonSaatavuusRuuduilla.vue"
    // Vesiliikenne
    import Rekisterointitoimipaikat from "@/views/Liikenne/Vesiliikenne/RightSlots/Rekisterointitoimipaikat.vue"
    import RekisteroidytVesikulkuneuvot from "@/views/Liikenne/Vesiliikenne/RightSlots/RekisteroidytVesikulkuneuvot.vue"

    // Posti
    import PostiHaeToimipaikkoja from "@/views/Viestinta/Posti/RightSlots/PostiHaeToimipaikkoja.vue"
    import PostiTarkasteleMaaraa from "@/views/Viestinta/Posti/RightSlots/PostiTarkasteleMaaraa.vue"

    // Infokartat
    import Infokartat from "@/views/Infokartat/Liikenne/RightSlots/Infokartat.vue"

    // Radiomikrofonitaajuudet
    import Radiomikrofonitaajuudet from "@/views/Viestinta/Radiomikrofonitaajuudet/RightSlots/Radiomikrofonitaajuudet.vue"

    // Bittimittari
    import BittimittariVuorokaudenaikaanPohjautuvatTiedot from "@/views/Viestinta/Bittimittari/RightSlots/BittimittariVuorokaudenaikaanPohjautuvatTiedot.vue"
    import BittimittariOperaattorikohtaisetTiedot from "@/views/Viestinta/Bittimittari/RightSlots/BittimittariOperaattorikohtaisetTiedot.vue"
    import BittimittariVuorokaudenaikaanPohjautuvatRuudut from "@/views/Viestinta/Bittimittari/RightSlots/BittimittariVuorokaudenaikaanPohjautuvatRuudut.vue"

    const { emit } = useEventsBus()

    @Component({
        components: {
            KiinteanLaajakaistanSaatavuus,
            Laajakaistahankkeet,
            OikeusPuhelinJaLaajakaistaLiittymaan,
            PostiHaeToimipaikkoja,
            PostiTarkasteleMaaraa,
            MyonnetytTaksiluvat,
            LupaJaRekisterointitoimipaikat,
            EnsirekisteroidytHenkiloAutot,
            EnsirekisteroidytHenkiloAutotPaastot,
            LiikennekaytossaHenkiloAutot,
            LiikennekaytossaHenkiloAutotKeskiIka,
            Liikenneonnettomuudet,
            VoimassaOlevatAjokortit,
            TVPeittoalueet,
            AntenniTVSaatavuus,
            RadioPeittoalueet,
            RadioasemienKuuluvuus,
            ViatJaHairiotTiedot,
            Rekisterointitoimipaikat,
            RekisteroidytVesikulkuneuvot,
            MobiiliverkonKattavuus,
            Infokartat,
            KiinteanVerkonSaatavuusRuuduilla,
            Radiomikrofonitaajuudet,
            BittimittariVuorokaudenaikaanPohjautuvatTiedot,
            BittimittariOperaattorikohtaisetTiedot,
            BittimittariVuorokaudenaikaanPohjautuvatRuudut,
            Guide
        }
    })
    export default class RightSlotTemplate extends Vue {
        @Prop({ type: String, default: "" }) guideText!: string

        get showRightSlot(): boolean {
            // Hae postitoimipaikkoja näkymässä rightslotia ei näytetä jos ollaan zoomattu liian kauas
            return this.$store.getters.layersVisible
        }

        // Storen kautta haetaan, mitä  halutaan näyttää
        get rightSlotName(): string | undefined {
            return this.$store.getters.rightSlot
        }

        get guideTextNotEmpty(): boolean {
            return this.guideText !== undefined && this.guideText.length > 0
        }

        get dataUpdatedDate(): string | null {
            const rightSlotData = this.$store.getters.rightSlotData
            if (rightSlotData != null) {
                return rightSlotData.dataUpdatedDate
            }
            else {
                return null
            }
        }

        get searchAddressSelected(): SearchResultModel | null {
            return this.$store.getters.searchAddressSelected
        }

        get isSearchAddressVisible(): boolean {
            return this.$store.getters.locationElementVisible
        }

        get searchFieldLabel(): string {
            if (this.rightSlotName === "Radiomikrofonitaajuudet") {
                return this.$t("App.Radiomikrofonitaajuudet.SearchAddressLabel")
            }
            return this.$t("App.SearchAddress.Heading.EnterLocation")
        }

        searchAddressFocus() {
            emit('addressInputFocus')
        }
    }
</script>

<style>
    .right-slot p {
        margin-bottom: 0px;
    }
</style>

<style scoped>
    .right-slot {
        padding: 0px 20px 20px 20px;
    }

    .dataUpdatedDate {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>
